/** @format */
import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./state.ts";
import { updateStorage } from "../../utilities/setting";
import _ from "lodash";

const createLocaleObj = (state) => {
  return {
    saveLocal: state.saveLocal,
    storeKey: state.storeKey,
    locale: _.cloneDeep(state.locale),
  };
};

export const localeSlice = createSlice({
  name: "locale",
  initialState,
  reducers: {
    setLang: (state, action) => {
      state.currentLang = action.payload;

      // updateStorage(state.saveLocal, state.storeKey, createLocaleObj(state));
    },
  },
});

export const { setLang } = localeSlice.actions;

export default localeSlice.reducer;
